import React from 'react'
import PropTypes from 'prop-types'

import { Popover, Divider, Typography, LinearProgress } from '@mui/material'

import UpcomingWorkOrders from './UpcomingWorkOrders'

const MAX_ROWS = 5

const UpcomingWorkOrdersPopover = ({ isLoading = false, anchorEl, serviceType, workOrders = [], onClose, ...rest }) => {
  const isOpen = Boolean(anchorEl)
  const rows = workOrders.slice(0, MAX_ROWS)
  const extraRows = workOrders.length - MAX_ROWS

  return (
    <Popover
      sx={{ pointerEvents: 'none' }}
      open={isOpen}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={onClose}
      disableRestoreFocus
      slotProps={{ paper: { sx: { minWidth: 300, p: 1 } } }}
      {...rest}
    >
      {isLoading && <LinearProgress />}
      <UpcomingWorkOrders serviceType={serviceType} workOrders={rows} />
      {extraRows > 0 && (
        <>
          <Divider />
          <Typography m={2} variant="caption" display="flex" justifyContent="end">
            {`+${extraRows} more`}
          </Typography>
        </>
      )}
    </Popover>
  )
}

UpcomingWorkOrdersPopover.propTypes = {
  isLoading: PropTypes.bool,
  anchorEl: PropTypes.object,
  serviceType: PropTypes.string.isRequired,
  workOrders: PropTypes.array,
  onClose: PropTypes.func.isRequired,
}

export default UpcomingWorkOrdersPopover
